const sections = document.querySelectorAll("section.numbers");

if (sections.length > 0) {

    const handleHandsHeight = (section, hands) => {
        if (!section || !hands) return;
        const sectionHeight = section.offsetHeight;
        hands.style.height = `${sectionHeight}px`;
    }

    sections.forEach(section => {
        const hands = section.querySelector(".numbers__hands.-desktop");
        handleHandsHeight(section, hands);
        window.addEventListener("resize", () => {
            handleHandsHeight(section, hands);
        })
    });
}